<template>
  <nav id="nav" class="fixed flex w-screen h-20 bg-black z-20">
    <div class="flex-shrink float-left h-full ml-4 md:ml-16 qhd:ml-64 justify-center">
      <a href="index.html"><img src="@/assets/img/Banner.png" alt=""
                                class="inline-block mt-6 md:mt-5 xl:mt-4 h-8 md:h-10 xl:h-12"></a>
    </div>
    <div class="flex-grow">

    </div>
    <div class="flex-shrink float-right leading-loose pt-5">
      <div class="hidden xl:inline-block align-middle mr-0 xl:mr-16 qhd:mr-48">
        <a href="index.html"
           class="menu fromLeft font-display text-white pb-1 text-lg font-bold mr-20">Home</a>
        <a href="" class="menu fromLeft font-display text-white pb-1 text-lg font-bold mr-20">Case Studies</a>
        <a href="about.html" class="menu fromLeft font-display text-white pb-1 text-lg font-bold mr-20">About
          Us</a>
        <a href="" class="menu fromLeft font-display text-white pb-1 text-lg font-bold mr-20">Contact</a>
        <a href=""
           class="w-48 h-6 p-6 pt-2 pb-2 font-display border-yellow-primary bg-yellow-primary rounded-full z-20">Customer
          portal</a>
      </div>
      <div class="inline-block xl:hidden align-middle mr-0 xl:mr-16 qhd:mr-48">
        <a href=""
           class="fromLeft font-display text-white pb-1 text-lg font-bold mr-6 md:mr-16 xl:mr-20">Menu</a>
      </div>
    </div>
  </nav>

</template>

<script>
  export default {
    name: 'NavBar',
    props: {
      msg: String
    }
  }
</script>

<style scoped>
  #nav {
    top: 0;
    left: 0;
    right: 0;
    padding: 0;
    margin: 0;
  }

  .menu {
    display: inline-block;
  }

  .menu:hover {
    color: #FFCF03;
  }

  .menu:after {
    display: block;
    content: '';
    border-bottom: solid 3px #FFCF03;
    transform: scaleX(0);
    transition: transform 125ms ease-in-out;
  }

  .menu.fromLeft:after {
    transition: none;
    transform: scaleX(0);
  }

  .menu.fromRight:after {
    transform-origin: 0% 50%;
  }

  .menu.fromLeft:hover:after {
    transition: transform 125ms ease-in-out;
    transform: scaleX(1);
    transform-origin: 0% 50%;
  }

  .menu.fromRight:hover:after {
    transform: scaleX(1);
    transform-origin: 100% 50%;
  }
</style>
